"use strict";
/**
 * Created on 10 24 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 *     Encapsulates data related to {@link WindowItem item} about "number of sites" with respect to {@link WindowItem.groupOfSitesId}.
 * </p>
 *
 * <p>
 *     In short, it mainly encapsulates set of ids of {@link InternalSite internal sites} where the product will be promoted with respect
 *     to validity of associated {@link Window window}, {@link GroupOfSites group of sites} and {@link ProductSiteBinding site assortment}.
 * </p>
 *
 * @author JMe
 */


var WindowItemSitesData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemSitesData, _DomainObject_1$Domai);

  /**
   * Ctor
   *
   * @param sites set of computed sites based on "number of sites" algorithm
   * @param delisted denotes that {@link WindowItem.productId} is delisted within all {@link this.sites}, false otherwise
   * @param notListedInEverySite denotes that {@link WindowItem.productId} is not listed in all site of {@link WindowItem.groupOfSitesId}.
   */
  function WindowItemSitesData(sites, delisted, notListedInEverySite) {
    var _this;

    _classCallCheck(this, WindowItemSitesData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSitesData).call(this));
    _this.sites = sites;
    _this.delisted = delisted;
    _this.notListedInEverySite = notListedInEverySite;
    return _this;
  }
  /**
   * Converter from data-dictionary representation.
   * @returns converted instance
   */


  _createClass(WindowItemSitesData, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new WindowItemSitesData(mat.sites, mat.delisted, mat.notListedInEverySite);
    }
    /**
     * @returns instance for provided product based on given data
     * @throws error if provided data does not contain given product
     */

  }, {
    key: "fromProductSitesData",
    value: function fromProductSitesData(productId, productSitesData) {
      var productSites = productSitesData.productSites,
          delistedProducts = productSitesData.delistedProducts,
          notListedInEverySite = productSitesData.notListedInEverySite;
      var sitesByProduct = productSites.get(productId, null);

      if (!sitesByProduct) {
        throw new Error("Cannot create sites data for product ".concat(productId, ", provided product sites does contain the product."));
      }

      var delisted = delistedProducts.contains(productId);
      var notListedInEverySiteFlag = notListedInEverySite.contains(productId);
      return new WindowItemSitesData(sitesByProduct, delisted, notListedInEverySiteFlag);
    }
  }]);

  return WindowItemSitesData;
}(DomainObject_1.DomainObject);

exports.WindowItemSitesData = WindowItemSitesData;
/**
 * {@link WindowItemSitesData} with empty set of sites and both flag values set to false
 */

WindowItemSitesData.EMPTY = new WindowItemSitesData(immutable_1.Set.of(), false, false);
/**
 * data-dictionary representation.
 */

WindowItemSitesData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemSitesData.name);
  return {
    sites: builder.setOf(builder.id('sites')),
    delisted: builder.bool('delisted'),
    notListedInEverySite: builder.bool('notListedInEverySite')
  };
}();